import { useState } from "react";
import "./App.css";

function App() {
  const [repoUrl, setRepoUrl] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

 const analyzeRepo = async () => {
  if (!repoUrl) {
    setError("Enter repo URL");
    return;
  }

  const isValid = /^https:\/\/github\.com\/[^/]+\/[^/]+\/?$/.test(repoUrl);

  if (!isValid) {
    setError("Enter a valid GitHub repository URL");
    return;
  }

  // ✅ Only now start loading
  // ✅ Reset state for new search
  setError("");
  setData(null);
  setLoading(true);

  try {
    const API_URL ="https://git-backend-u00j.onrender.com";
    const res = await fetch(`${API_URL}/analyze`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ repoUrl }),
    });

    const result = await res.json();

    if (!res.ok) {
      setError(result.error || "Failed to analyze repository");
    } else {
      setData(result.data);
    }

  } catch (err) {
    console.error(err);
    setError("Error connecting to backend");
  }

  setLoading(false);
};

  return (
    <div className="container">
      <h1>🚀 GitHub Repo Analyzer</h1>
      <p className="tagline">Powered by AI 🤖</p>

      <div className="input-box">
        <input
          type="text"
          placeholder="Enter GitHub Repo URL"
          value={repoUrl}
          onChange={(e) => setRepoUrl(e.target.value)}
        />
        <button onClick={analyzeRepo}>Analyze</button>
      </div>

      {loading && <p>Analyzing... ⏳</p>}
       
      {error && <p className="error">❌ {error}</p>}

      {data && (
        <div className="card">
          <p className="ai-badge">🤖 AI Generated Insights</p>

          <h2>Summary</h2>
          <p>{data.summary}</p>

          <h3>Tech Stack</h3>
          <ul>
            {data.tech_stack?.map((t, i) => (
              <li key={i}>{t}</li>
            ))}
          </ul>

          <h3>Improvements</h3>
          <ul>
            {data.improvements?.map((i, idx) => (
              <li key={idx}>{i}</li>
            ))}
          </ul>

          <h3>Complexity</h3>
          <p>{data.complexity}</p>
          <h3>README Quality</h3>
          <p>{data.readme}</p>
          <h3>Score</h3>
          <p>{data.score}/10</p>
        </div>
      )}

      <footer className="footer">
        Built with AI • GitHub Analyzer
      </footer>
    </div>

    
  );
}

export default App;
